import { Link } from "react-router-dom";
import {
  ArrowRight, BadgeEuro, CalendarCheck, FileCheck2, HandCoins, MousePointerClick, Phone, ShieldCheck,
} from "lucide-react";

const ZAHLEN = [
  { big: "0 €", small: "kostet dich die Aufnahme — dauerhaft" },
  { big: "40 €", small: "netto zahlt der Betrieb pro Einsatztag, nicht du" },
  { big: "1 Klick", small: "für Zusage oder Absage, ohne Login" },
];

const VORTEILE = [
  {
    icon: HandCoins,
    title: "Für dich komplett kostenlos",
    text: "Keine Aufnahmegebühr, keine Monatsgebühr, keine Beteiligung an deinem Honorar. Die Vermittlungsprovision zahlt immer der Betrieb. Du rechnest deine Leistung direkt mit ihm ab — wie gewohnt, zu deinem Satz.",
  },
  {
    icon: MousePointerClick,
    title: "Anfragen kommen zu dir",
    text: "Du bekommst eine E-Mail mit Betrieb, Tagen, Uhrzeit, Posten und Tagessatz. Ein Klick auf „Ich kann“ genügt — oder du nennst deinen eigenen Tagessatz. Kein Portal-Zwang, keine App, kein Passwort.",
  },
  {
    icon: CalendarCheck,
    title: "Du bestimmst, wann du frei bist",
    text: "In deinem persönlichen Bereich trägst du nur die Tage ein, an denen du nicht kannst. Alles andere gilt als frei. So bekommst du nur Anfragen, die wirklich in deinen Kalender passen.",
  },
  {
    icon: ShieldCheck,
    title: "Du bleibst selbstständig",
    text: "Keine Annahmepflicht, keine Weisungen, keine Arbeitnehmerüberlassung. Du entscheidest bei jedem Einsatz neu. Und weil ich selbst am Herd stehe, weißt du: Ich verspreche keinem Betrieb etwas, was in der Küche nicht machbar ist.",
  },
  {
    icon: BadgeEuro,
    title: "Auch Festanstellung möglich",
    text: "Wenn du eigentlich etwas Festes suchst, hinterlege einfach deinen Gehaltswunsch. Betriebe aus meinem Netzwerk suchen regelmäßig Küchenpersonal in Festanstellung — auch das kostet dich nichts.",
  },
  {
    icon: FileCheck2,
    title: "Klare Verträge, keine Kleingedruckten",
    text: "Den Vermittlungsvertrag kannst du vorab in Ruhe als PDF lesen und digital unterschreiben. Darin steht genau, was ich mache, was du machst — und dass du nichts zahlst.",
  },
];

const SCHRITTE = [
  {
    nr: "01",
    title: "Profil anlegen",
    text: "Rund 5 Minuten: Land, Kontaktdaten, Wohnort und Umkreis, deine Bereiche und Posten, dein Stunden- oder Tagessatz. Dabei kreuzt du an, ob du Betriebseinsätze, Private Dining oder beides machen willst. Dazu die drei Unterlagen — und fertig.",
  },
  {
    nr: "02",
    title: "Ich schalte dich frei",
    text: "Ich schaue mir dein Profil persönlich an, prüfe die Unterlagen und melde mich. Danach bekommst du deinen persönlichen Link — den speicherst du am besten als Lesezeichen.",
  },
  {
    nr: "03",
    title: "Einsätze annehmen",
    text: "Passt ein Einsatz in deinen Umkreis und deine freien Tage, bekommst du die Anfrage. Du sagst zu, ich bestätige dem Betrieb — und du stehst am Herd statt am Schreibtisch.",
  },
];

const UNTERLAGEN = [
  ["Gewerbeanmeldung", "Zeigt, dass du selbstständig tätig bist."],
  ["Lebenslauf", "Damit ich weiß, welche Küchen und Posten du kennst."],
  ["Belehrung nach § 43 IfSG", "Das Gesundheitszeugnis — verlangt jeder Betrieb ohnehin."],
];

const FAQ = [
  ["Was kostet mich das wirklich?",
   "Nichts. Nicht bei der Aufnahme, nicht monatlich, nicht pro Einsatz. Die Provision von 40 € netto je Einsatztag zahlt der Betrieb an mich — dein Honorar bleibt vollständig bei dir."],
  ["Muss ich Einsätze annehmen?",
   "Nein. Du entscheidest bei jeder Anfrage frei und musst keinen Grund nennen. Nur wenn du zugesagt hast, verlasse ich mich darauf — dann brauche ich im Notfall bitte sofort einen Anruf."],
  ["Bekomme ich ständig E-Mails?",
   "Nein. Du bekommst nur Anfragen, die zu deinem Umkreis, deinen Bereichen und deinen freien Tagen passen. Wer seine belegten Tage pflegt, hört von mir fast nur dann, wenn es wirklich passt."],
  ["Binde ich mich an dich?",
   "Nein, in keiner Weise. Kein Kundenschutz, keine Vertragsstrafe, keine Exklusivität, keine Kündigungsfrist. Du darfst jederzeit direkt mit jedem Betrieb arbeiten, auch mit einem, den ich dir vermittelt habe, und parallel mit anderen Vermittlern. Wenn du Folgeeinsätze weiter über mich laufen lässt, freut mich das — verpflichtet bist du nicht."],
  ["Wer haftet bei einem Einsatz?",
   "Du erbringst die Leistung als Selbstständiger und brauchst dafür eine Betriebs- bzw. Berufshaftpflicht. Ich bin Vermittler, nicht dein Auftraggeber — was ihr vor Ort abrechnet, klärst du direkt mit dem Betrieb."],
  ["Wie weit fahre ich?",
   "Genau so weit, wie du willst: Du gibst deinen Umkreis in Kilometern an, und das System schlägt dich nur für Betriebe innerhalb dieser Entfernung vor. Das gilt auch über die Grenze — wohnst du etwa bei Salzburg, siehst du auch Einsätze in Oberbayern."],
  ["Kann ich auch bei Privatkunden kochen?",
   "Ja. Setze im Formular einfach das Häkchen „Ich koche auch für Privatkunden“. Dann schlage ich dich auch für Private Dining, Geburtstage und Familienfeiern vor. Ohne Häkchen bekommst du ausschließlich Anfragen aus Betrieben — du kannst es jederzeit ändern, sag mir einfach Bescheid."],
  ["Ich bin aus Österreich — geht das auch?",
   "Ja. Bei der Registrierung wählst du Deutschland oder Österreich. Statt Gewerbeanmeldung und § 43-IfSG-Belehrung lädst du dann deinen Gewerbeschein und die Hygieneschulung nach LMSVG hoch. Für Einsätze über die Grenze brauchst du in der Regel eine A1-Bescheinigung — ich sage dir rechtzeitig Bescheid und unterstütze dich bei den Unterlagen."],
];

export default function MietkochWerden() {
  return (
    <div data-testid="mietkoch-werden-page">
      {/* HERO */}
      <section className="border-b border-[#E3DECE]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
          <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
            <div className="lg:col-span-7">
              <p className="text-[10px] uppercase tracking-[0.35em] text-[#BA6D52]">
                Für selbstständige Mietköche & Privatköche
              </p>
              <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter mt-6 leading-[1.06]">
                Du kochst.<br />
                Die Aufträge<br className="hidden sm:block" /> suche ich.
              </h1>
              <p className="text-[#757067] font-light text-base md:text-lg leading-[1.85] mt-7 max-w-xl">
                Ich bin Lukas Stutz, gelernter Koch und selbst als Mietkoch unterwegs. Über mein
                Netzwerk vermittle ich Einsätze an selbstständige Kollegen — in Restaurants, Hotels,
                bei Caterern und auf Veranstaltungen und, wenn du magst, auch Private Dining bei
                Privatkunden zu Hause. In Deutschland und Österreich.
                <b className="text-[#2C2A26] font-medium"> Für dich ist das dauerhaft kostenlos.</b>
              </p>
              <div className="mt-10 flex flex-wrap gap-3">
                <Link to="/vermittlung/koch-registrieren" data-testid="mkw-cta-top"
                  className="inline-flex items-center gap-3 bg-[#BA6D52] text-white hover:bg-[#9E5841] px-8 py-5 text-xs uppercase tracking-[0.2em] transition-colors">
                  Jetzt ins Netzwerk <ArrowRight size={16} />
                </Link>
                <a href="tel:+4915127282560" data-testid="mkw-cta-call"
                  className="inline-flex items-center gap-3 border border-[#E3DECE] text-[#2C2A26] hover:border-[#BA6D52] hover:text-[#BA6D52] px-8 py-5 text-xs uppercase tracking-[0.2em] transition-colors">
                  <Phone size={15} /> Erst kurz sprechen
                </a>
              </div>
              <p className="text-xs text-[#757067] mt-5">
                5 Minuten Aufwand · keine Gebühren · kein Abo · jederzeit kündbar
              </p>
            </div>
            <div className="lg:col-span-5">
              <div className="relative">
                <img
                  src="https://images.unsplash.com/photo-1566554273541-37a9ca77b91f?w=1200&q=80&auto=format&fit=crop"
                  alt="Koch beim Anrichten in der Küche"
                  className="w-full h-[380px] lg:h-[520px] object-cover"
                />
                <div className="absolute -bottom-5 -left-5 hidden sm:block bg-[#2C2A26] text-[#F2EFE9] px-7 py-5">
                  <p className="font-serif text-3xl font-light">0 €</p>
                  <p className="text-[10px] uppercase tracking-[0.2em] text-[#B3ADA2] mt-1">
                    für dich, immer
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ZAHLEN */}
      <section className="bg-[#2C2A26] text-[#F2EFE9]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 grid sm:grid-cols-3 gap-px bg-[#403C36]">
          {ZAHLEN.map((z) => (
            <div key={z.big} className="bg-[#2C2A26] px-6 py-8">
              <p className="font-serif text-4xl font-light text-[#D69173]">{z.big}</p>
              <p className="text-sm text-[#B3ADA2] font-light mt-3 leading-relaxed">{z.small}</p>
            </div>
          ))}
        </div>
      </section>

      {/* VORTEILE */}
      <section className="border-b border-[#E3DECE]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#BA6D52]">Was du davon hast</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight mt-6 max-w-2xl leading-[1.12]">
            Weniger Papierkram.<br />Mehr Tage am Herd.
          </h2>
          <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
            {VORTEILE.map((v) => (
              <div key={v.title} data-testid={`mkw-vorteil-${v.title.slice(0, 12)}`}>
                <v.icon size={26} strokeWidth={1.3} className="text-[#BA6D52]" />
                <h3 className="font-serif text-xl md:text-2xl font-light mt-5 leading-snug">{v.title}</h3>
                <p className="text-sm text-[#575349] font-light leading-[1.8] mt-3">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SCHRITTE */}
      <section className="border-b border-[#E3DECE] bg-[#F2EFE9]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#BA6D52]">So läuft es ab</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight mt-6 leading-[1.12]">
            Drei Schritte — und du bist dabei.
          </h2>
          <div className="mt-14 grid md:grid-cols-3 gap-10">
            {SCHRITTE.map((s) => (
              <div key={s.nr} className="border-t-2 border-[#BA6D52] pt-6">
                <p className="font-serif text-4xl font-light text-[#CFC9BE]">{s.nr}</p>
                <h3 className="font-serif text-2xl font-light mt-4">{s.title}</h3>
                <p className="text-sm text-[#575349] font-light leading-[1.8] mt-3">{s.text}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-white border border-[#E3DECE] p-8 md:p-10">
            <h3 className="font-serif text-2xl font-light">Das brauchst du für die Anmeldung</h3>
            <p className="text-sm text-[#757067] mt-2">
              Am besten gleich als Foto oder PDF bereitlegen — dann bist du in 5 Minuten durch.
            </p>
            <div className="mt-7 grid sm:grid-cols-3 gap-8">
              {UNTERLAGEN.map(([t, d]) => (
                <div key={t} className="flex gap-3">
                  <FileCheck2 size={18} className="text-[#BA6D52] shrink-0 mt-1" strokeWidth={1.5} />
                  <div>
                    <p className="text-[#2C2A26] font-medium text-sm">{t}</p>
                    <p className="text-xs text-[#757067] leading-relaxed mt-1">{d}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="border-b border-[#E3DECE]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#BA6D52]">Ehrliche Antworten</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight mt-6 leading-[1.12]">
            Was Kollegen mich fragen.
          </h2>
          <div className="mt-12 grid md:grid-cols-2 gap-x-14 gap-y-10">
            {FAQ.map(([q, a]) => (
              <div key={q} data-testid={`mkw-faq-${q.slice(0, 10)}`}>
                <h3 className="text-[#2C2A26] font-medium">{q}</h3>
                <p className="text-sm text-[#575349] font-light leading-[1.8] mt-2">{a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#2C2A26] text-[#F2EFE9]">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-20 md:py-28 text-center">
          <p className="text-xs uppercase tracking-[0.25em] text-[#D69173]">Nächster Schritt</p>
          <h2 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mt-6 leading-[1.1]">
            Fünf Minuten jetzt.<br />Einsätze später.
          </h2>
          <p className="text-[#B3ADA2] font-light leading-relaxed mt-6 max-w-xl mx-auto">
            Leg dein Profil an — ich schaue es mir persönlich an und melde mich bei dir. Du gehst
            damit keine Verpflichtung ein und kannst jederzeit wieder aussteigen.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            <Link to="/vermittlung/koch-registrieren" data-testid="mkw-cta-bottom"
              className="inline-flex items-center gap-3 bg-[#BA6D52] text-white hover:bg-[#9E5841] px-8 py-5 text-xs uppercase tracking-[0.2em] transition-colors">
              Jetzt ins Netzwerk <ArrowRight size={16} />
            </Link>
            <a href="/api/vermittlung/vertrag/mietkoch.pdf" target="_blank" rel="noreferrer"
              data-testid="mkw-vertrag-pdf"
              className="inline-flex items-center gap-3 border border-[#4A453D] text-[#F2EFE9] hover:border-[#D69173] hover:text-[#D69173] px-8 py-5 text-xs uppercase tracking-[0.2em] transition-colors">
              Vertrag vorab lesen
            </a>
          </div>
          <p className="text-sm text-[#8A8378] mt-8">
            Lieber erst sprechen? <a href="tel:+4915127282560" className="text-[#D69173] hover:underline">+49 151 27282560</a>
          </p>
        </div>
      </section>
    </div>
  );
}
